import { render, staticRenderFns } from "./IpBundleAdd.vue?vue&type=template&id=1e5addc6&"
import script from "./IpBundleAdd.vue?vue&type=script&lang=js&"
export * from "./IpBundleAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports